import { render } from "./MenuManager.vue?vue&type=template&id=5901047f&scoped=true"
import script from "./MenuManager.vue?vue&type=script&lang=js"
export * from "./MenuManager.vue?vue&type=script&lang=js"

import "./MenuManager.vue?vue&type=style&index=0&id=5901047f&scoped=true&lang=css"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5901047f"]])

export default __exports__